var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { staticClass: "modal-title" }, [_vm._v(" FORM ")]),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_form.title.$error } },
        [
          _c("label", [_vm._v(" Form Title ")]),
          _vm._v(" "),
          _c("j-input", {
            attrs: { "max-length": 255, placeholder: "Form Title" },
            model: {
              value: _vm.$v.data_form.title.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_form.title, "$model", $$v)
              },
              expression: "$v.data_form.title.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_form.form.$error } },
        [
          _c("label", [_vm._v(" Select Form ")]),
          _vm._v(" "),
          _c("j-single-select", {
            attrs: {
              "load-options": _vm.loadOptionsForm,
              "is-async": true,
              "cache-option": false,
              placeholder: "Select Form",
              "value-format": "object",
              label: "name"
            },
            model: {
              value: _vm.$v.data_form.form.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_form.form, "$model", $$v)
              },
              expression: "$v.data_form.form.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_form.field.$error } },
        [
          _c("label", [_vm._v(" Select Field ")]),
          _vm._v(" "),
          _c("j-multi-select", {
            attrs: {
              options: _vm.list_field,
              label: "name",
              "value-format": "object",
              placeholder: "Select Field"
            },
            model: {
              value: _vm.$v.data_form.field.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_form.field, "$model", $$v)
              },
              expression: "$v.data_form.field.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", [
            _c(
              "div",
              { staticClass: "float-to-right" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn gray m__r--5",
                    on: { click: _vm.closeForm }
                  },
                  [_vm._v("\n          Close\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  { staticClass: "btn blue", on: { click: _vm.saveForm } },
                  [_vm._v("\n          Save\n        ")]
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalCreateForm",
          staticClass: "mod-form",
          attrs: { centered: "" }
        },
        [
          _c("label", [_vm._v("CREATE FORM")]),
          _vm._v(" "),
          _c(
            "b-form-group",
            { class: { "error-input": _vm.$v.data_create_form.name.$error } },
            [
              _c("label", [_vm._v(" Form Name ")]),
              _vm._v(" "),
              _c("j-input", {
                attrs: { "max-length": 255, placeholder: "Form Name" },
                model: {
                  value: _vm.$v.data_create_form.name.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.data_create_form.name, "$model", $$v)
                  },
                  expression: "$v.data_create_form.name.$model"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              class: {
                "error-input": _vm.$v.data_create_form.description.$error
              }
            },
            [
              _c("label", [_vm._v(" Description ")]),
              _vm._v(" "),
              _c("j-textarea", {
                attrs: { "max-length": 300, placeholder: "Description" },
                model: {
                  value: _vm.$v.data_create_form.description.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.data_create_form.description, "$model", $$v)
                  },
                  expression: "$v.data_create_form.description.$model"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-form-container" },
            [
              _c("j-form-master", {
                ref: "jFormMasterData",
                attrs: { "list-field": _vm.listField }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray m__r--5",
                        on: { click: _vm.closeCreateForm }
                      },
                      [_vm._v("\n            Close\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn blue",
                        on: { click: _vm.createForm }
                      },
                      [_vm._v("\n            Finish\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54ff0c4f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54ff0c4f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/pages-component/jFormSetup.vue
// module id = null
// module chunks = 